import { useStore } from "../../../context/StoreContext";

const SelectStoreCard = ({ store, storeType }) => {
  const { selectedStore, updateSelectedStore, updateSelectedDestStore } =
    useStore();

  const type = storeType || store.type; // "source" | "destination"
  const isSelected = selectedStore?.id === store.id;

  const handleSelect = () => {
    if (!store.isActive || isSelected) return;

    updateSelectedStore({
      id: store.id,
      public_name: store.public_name,
      type,
      status: store.status,
      isApproved: store.isApproved,
      isActive: store.isActive,
      isWhatsappEnabled: store.isWhatsappEnabled,
    });

    if (type === "destination") {
      updateSelectedDestStore({
        id: store.id,
        public_name: store.public_name,
        type,
        status: store.status,
        isApproved: store.isApproved,
        isActive: store.isActive,
        isWhatsappEnabled: store.isWhatsappEnabled,
      });
    }
  };

  return (
    <div
      className={`card ${isSelected ? "border-success" : ""}`}
      style={{ maxWidth: 340 }}
    >
      <div className="card-body d-flex align-items-center justify-content-between gap-3 py-3">
        <div className="min-w-0">
          <div className="fw-semibold text-truncate">{store.public_name}</div>
          <span
            className={`badge ${store.isActive ? "bg-success" : "bg-secondary"}`}
          >
            {store.isActive ? "Active" : "Not active"}
          </span>
        </div>

        <button
          type="button"
          className={`btn btn-sm ${isSelected ? "btn-outline-success" : "btn-success"}`}
          onClick={handleSelect}
          disabled={isSelected || !store.isActive}
          title={!store.isActive ? "Activate this store first" : undefined}
        >
          {isSelected ? (
            <>
              <i className="bi bi-check-circle me-1" aria-hidden="true" />
              Selected
            </>
          ) : (
            "Use this store"
          )}
        </button>
      </div>
    </div>
  );
};

export default SelectStoreCard;
